// extracted by mini-css-extract-plugin
export default {"switchList":"PresentationConfigs__switchList-RSUBz","noMarginTop":"PresentationConfigs__noMarginTop-YoO7t"};